"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _ossUpload = require("@/utils/ossUpload");
var _feedback = require("@/api/member/feedback");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'Feedback',
  data: function data() {
    return {
      queryData: {
        nickname: '',
        memberId: '',
        phone: '',
        page: 1,
        size: 10
      },
      myFileList: [],
      fileList: [],
      dialogImageUrl: '',
      dialogVisible1: false,
      tableData: [],
      dialogVisible: false,
      recoverQuery: {
        id: '',
        feedbackResult: ''
      },
      total: null,
      loading: false
    };
  },
  created: function created() {
    this.queryMemberSuggestsApi();
  },
  methods: {
    handleFileUpload: function () {
      var _handleFileUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(_ref) {
        var file, pictureUrl, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              file = _ref.file;
              _context.p = 1;
              _context.n = 2;
              return (0, _ossUpload.uploadOSS)(file);
            case 2:
              pictureUrl = _context.v;
              this.fileList.push({
                url: pictureUrl,
                uid: file.uid
              });
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.log('error ->', _t);
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3]]);
      }));
      function handleFileUpload(_x) {
        return _handleFileUpload.apply(this, arguments);
      }
      return handleFileUpload;
    }(),
    handleRemove: function handleRemove(file) {
      this.fileList = this.fileList.filter(function (i) {
        return i.uid !== file.uid;
      });
    },
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible1 = true;
    },
    onUserDetails: function onUserDetails(value) {
      this.$router.push({
        path: 'userDetails',
        query: {
          memberId: value.memberId,
          nickname: value.nickname
        }
      });
    },
    // 查询
    onInquire: function onInquire() {
      this.queryData.page = 1;
      this.queryData.size = 10;
      this.queryMemberSuggestsApi();
    },
    // 重置
    onReset: function onReset() {
      this.queryData = {
        nickname: '',
        memberId: '',
        phone: '',
        page: 1,
        size: 10
      };
      this.queryMemberSuggestsApi();
    },
    // 回复
    onRecover: function onRecover(val) {
      this.recoverQuery.id = val.id;
      this.dialogVisible = true;
    },
    // 弹窗关闭
    handleClose: function handleClose() {
      this.recoverQuery.feedbackResult = '';
      this.myFileList = [];
      this.fileList = [];
      this.dialogVisible = false;
    },
    // 确认
    onVerify: function onVerify() {
      var _this = this;
      if (!this.recoverQuery.feedbackResult) {
        this.$message({
          type: 'error',
          message: '请填写内容'
        });
        return;
      }
      this.$confirm('确认回复?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this.suggestRecoverApi();
      }).catch(function () {
        _this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.queryData.size = val;
      this.queryMemberSuggestsApi();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryData.page = val;
      this.queryMemberSuggestsApi();
    },
    queryMemberSuggestsApi: function () {
      var _queryMemberSuggestsApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var params, res, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              this.loading = true;
              _context2.p = 1;
              params = (0, _objectSpread2.default)({}, this.queryData);
              _context2.n = 2;
              return (0, _feedback.queryMemberSuggestsApi)(params);
            case 2:
              res = _context2.v;
              this.loading = false;
              if (res.code === 0) {
                this.tableData = res.data.data;
                this.total = res.data.total;
              }
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t2 = _context2.v;
              this.loading = false;
              console.log(_t2);
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 3]]);
      }));
      function queryMemberSuggestsApi() {
        return _queryMemberSuggestsApi2.apply(this, arguments);
      }
      return queryMemberSuggestsApi;
    }(),
    suggestRecoverApi: function () {
      var _suggestRecoverApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3() {
        var params, res, _t3;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              params = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.recoverQuery), {}, {
                recoverPictureUrl: this.fileList.map(function (i) {
                  return i.url;
                })
              });
              _context3.n = 1;
              return (0, _feedback.suggestRecoverApi)(params);
            case 1:
              res = _context3.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '回复成功'
                });
                this.handleClose();
                this.onReset();
              }
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t3 = _context3.v;
              console.log(_t3);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function suggestRecoverApi() {
        return _suggestRecoverApi2.apply(this, arguments);
      }
      return suggestRecoverApi;
    }()
  }
};